import {booleanAttribute, ChangeDetectionStrategy, Component, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {EntitetType} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatIcon} from "@angular/material/icon";

const debug = initDebugger('EntitetikonKomponent');

/**
 * Viser ikon for angitt entitetstype.
 */
@Component({
    selector: 'entitetikon',
    templateUrl: 'entitetikon.html',
    styleUrl: 'entitetikon.scss',
    host: {'[style.--størrelse]': 'stoerrelse() ?? (inline() ? "inherit" : "24px") '},
    imports: [
        MatIcon
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntitetikonKomponent {

    type = input.required<EntitetType|EntitetTypeStreng>();
    inline = input(false, {transform: booleanAttribute});
    /** Størrelse på ikon, overstyrere standard størrelse på 24px dersom angitt, eks `stoerrelse="40px"`.
     * Dersom inline er angitt og ingen eksplisitt størrelse er angitt settes størrelse til 'inherit' */
    stoerrelse = input<string|null>(null);

    typer = EntitetType;
}

export type EntitetTypeStreng = `${EntitetType}`;
